import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Footer from "../Layout/Footer";
import Header from "../Layout/Header";
import { gpColors } from "../../constants/colors";
import { Container, Divider } from "@material-ui/core";
import qualityControl from "../../Images/thumbnail_quality-control.png";
import manufacturing from "../../Images/thumbnail_manufacturing.png";
import quality from "../../Images/thumbnail_quality.png";
import qual from "../../Images/quality.png";
import certification from "../../Images/thumbnail_certification.png";
import customerSatisfication from "../../Images/thumbnail_satisfaction.png";
import research from "../../Images/thumbnail_research-and-development.png";
import { Helmet } from "react-helmet";
import usePhoneSize from "../responsive/usePhoneSize";
import useTabletSize from "../responsive/useTabletSize";


const useStyles = makeStyles((theme) => ({
  container: {
    width: "100%",
    padding: "30px",
    position: "relative",
    marginTop: "75px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "105px",
    },
  },
  qualityHeader: {
    fontWeight: 900,
    fontSize: "20px",
    height: "53px",
    background: "#36404b",
    margin: "0px",
    lineHeight: "58px",
    letterSpacing: "1px",
    textAlign: "center",
    color: "#fff",
    position: "relative",
    width: "260px",
    marginBottom: "30px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:before": {
      content: "''",
      left: "-20px",
      borderStyle: "solid",
      borderWidth: "0 0 53px 20px",
      borderColor: `transparent transparent ${gpColors.logoBrown} transparent`,
      position: "absolute",
    },
    "&:after": {
      content: "''",
      right: "-20px",
      borderStyle: "solid",
      borderWidth: "53px 20px 0 0",
      borderColor: `${gpColors.logoBrown} transparent transparent transparent`,
      position: "absolute",
    },
  },
  qualityContent: {
    fontSize: "16px",
    lineHeight: 2,
    textAlign: "justify",
    fontWeight:'900',
    color:'black'
  },
  bulletHeadings: {
    fontWeight: 900,
    fontSize: "17px",
    // paddingTop:'3%'
  },
  QualityDev: {
    // backgroundColor: "white",
    width: "100%",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    justifyContent: "center",
    marginTop: "1%",
    boxShadow: "5px 10px 15px grey",
    paddingTop: "5%",
    paddingBottom: "5%",
  },
  QualityPara: {
    width: "30%",
    // paddingLeft: "5%",
    // paddingRight: "5%",
    alignItems: "center",
    boxShadow: '3px 7px 12px #BFBFBF',
  },
  textstyle: {
    fontSize: "14px",
    fontWeight: 500,
    textAlign: 'justify',
    paddingLeft: '11px',
    paddingRight: '11px'
  },
  imageContainer: {
    width: "100%",
  },
}));
const Quality = () => {
  const classes = useStyles();
  const phonesize = usePhoneSize()
  const tabletsize = useTabletSize()
  useEffect(() => {
    // console.log('rendered')
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        {/* <title>My Title</title> */}
        <meta name="keywords" content="" />
        <meta
          name="description"
          content="Experience superior quality automotive filters that deliver unmatched performance and reliability. Our stringent manufacturing processes and rigorous quality control ensure the highest standards in filtration.Trust our ISO-certified quality management system for dependable filters that protect your vehicles. Explore our commitment to excellence and customer satisfaction on our quality page.."
        />
      </Helmet>
      <Header />
      <Container>
        <div className={classes.container}>
          <div>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
              }}
            >
              <div className={classes.qualityHeader}>Quality</div>
            </div>
            <div className={classes.qualityContent}>
              <p>
                At GuardPlus, we are committed to delivering high-quality
                automotive filters that meet and exceed industry standards. Our
                dedication to excellence, rigorous manufacturing processes, and
                strict quality control measures ensure that our filters perform
                optimally and provide reliable protection for your vehicles.
              </p>

              <div className={classes.QualityDev}
                style={{ display: phonesize ? 'block' : 'flex' }}
              >
                <div
                  className={classes.QualityPara}
                  style={{
                    // paddingRight:phonesize?'auto':"5%",
                    width: phonesize ? '100%' : '30%',
                    margin: '6px',
                  }}
                >
                  <div
                    class='img1 imges'
                    style={{height:tabletsize?phonesize?'auto':'600px':'420px'}}
                  >
                    {/*<div className={classes.imageContainer}>
                     {" "}
                     <img
                       src={quality}
                       alt={'quality'}
                       style={{
                         objectFit: "contain",
                         width: "25%",
                         height: "25%",
                       }}
                     />
                     </div>*/}
                    <p>
                      <span className={classes.bulletHeadings}>
                        Product Quality
                      </span>
                    </p>
                    <p className={classes.textstyle}>
                      We pride ourselves on producing automotive filters that are
                      built to last and deliver superior performance. We use
                      premium quality materials and advanced manufacturing
                      techniques to create filters that effectively remove
                      contaminants, provide excellent filtration efficiency, and
                      enhance the overall performance of your vehicle.
                    </p>
                  </div>
                </div>


                <div
                  className={classes.QualityPara}
                  style={{
                    // paddingRight:phonesize?'auto':"5%",
                    width: phonesize ? '100%' : '30%',
                    margin: '6px',
                  }}
                >
                  <div
                    class='img2 imges'
                    style={{height:tabletsize?phonesize?'auto':'600px':'420px'}}
                  >
                    <p>
                      <span className={classes.bulletHeadings}>
                        Manufacturing Processes
                      </span>
                    </p>
                    <p className={classes.textstyle}>
                      Our state-of-the-art manufacturing facility employs
                      cutting-edge technology and follows industry best practices.
                      From design to production, every step is carefully monitored
                      to maintain the highest quality standards. We adhere to
                      stringent quality control protocols to ensure consistency
                      and reliability in every filter that leaves our facility.
                    </p>
                  </div>
                </div>

                <div
                  className={classes.QualityPara}
                  style={{
                    // paddingRight:phonesize?'auto':"5%",
                    width: phonesize ? '100%' : '30%',
                    margin: '6px',
                  }}
                >
                  <div
                    class='img3 imges'
                    style={{height:tabletsize?phonesize?'auto':'600px':'420px'}}
                  >
                    <p>
                      <span className={classes.bulletHeadings}>
                        Quality Control
                      </span>
                    </p>
                    <p className={classes.textstyle}>
                      We have implemented a comprehensive quality control system
                      to guarantee the reliability and effectiveness of our
                      filters. Our experienced quality assurance team conducts
                      rigorous testing at various stages of the manufacturing
                      process. This includes material inspections, performance
                      testing, and fitment verification, among others. We are
                      committed to delivering filters that meet or exceed industry
                      specifications.
                    </p>
                  </div>
                </div>


                <div
                  className={classes.QualityPara}
                  style={{
                    // paddingRight:phonesize?'auto':"5%",
                    width: phonesize ? '100%' : '30%',
                    margin: '6px',
                  }}
                >
                  <div
                    class='img4 imges'
                    style={{height:tabletsize?phonesize?'auto':'600px':'420px'}}
                  >
                    <p>
                      <span className={classes.bulletHeadings}>
                        Certifications and Compliance
                      </span>
                    </p>
                    <p className={classes.textstyle}>
                      We understand the importance of adhering to industry
                      standards and regulations. Our company holds certifications
                      such as ISO 9001, demonstrating our commitment to quality
                      management systems. These certifications validate our
                      processes, ensuring that we consistently meet customer
                      requirements and deliver reliable products.
                    </p>

                  </div>
                </div>


                <div
                  className={classes.QualityPara}
                  style={{
                    // paddingRight:phonesize?'auto':"5%",
                    width: phonesize ? '100%' : '30%',
                    margin: '6px',
                  }}
                >
                  <div
                    class='img5 imges'
                    style={{height:tabletsize?phonesize?'auto':'600px':'420px'}}
                  >
                    <p>
                      <span className={classes.bulletHeadings}>
                        Customer Satisfaction
                      </span>
                    </p>
                    <p className={classes.textstyle}>
                      Customer satisfaction is at the core of our business. We
                      value feedback from our customers and continuously strive to
                      improve our products and services. Our customer support team
                      is always ready to assist you with any inquiries or concerns
                      you may have.
                    </p>
                  </div>
                </div>


                <div
                  className={classes.QualityPara}
                  style={{
                    // paddingRight:phonesize?'auto':"5%",
                    width: phonesize ? '100%' : '30%',
                    margin: '6px',
                  }}
                >
                  <div
                    class='img6 imges'
                    style={{height:tabletsize?phonesize?'auto':'600px':'420px'}}
                  >

                    <p>
                      <span className={classes.bulletHeadings}>
                        Research and Development
                      </span>
                    </p>
                    <p className={classes.textstyle}>
                      We invest in ongoing research and development to stay at the
                      forefront of automotive filter technology. By staying
                      up-to-date with the latest advancements, we can continually
                      enhance the performance and efficiency of our filters. Our
                      goal is to provide filters that contribute to the longevity
                      and optimal functioning of your vehicles.
                    </p>
                  </div>
                </div>


              </div>




              {/* <div className={classes.QualityDev}> */}

                {/*<div
                  className={classes.QualityPara}
                  style={{
                    paddingRight: "5%",

                  }}
                >
                  <div
                  >
                    <div className={classes.imageContainer}>
                      {" "}
                      <img
                        src={quality}
                        alt={'quality'}
                        style={{
                          objectFit: "contain",
                          // width: "25%",
                          // height: "25%",
                          width: 70,
                          height: 70,
                        }}
                      />
                    </div>
                    <p>
                      <span className={classes.bulletHeadings}>
                        Product Quality
                      </span>
                    </p>

                    <p className={classes.textstyle}>
                      We pride ourselves on producing automotive filters that are
                      built to last and deliver superior performance. We use
                      premium quality materials and advanced manufacturing
                      techniques to create filters that effectively remove
                      contaminants, provide excellent filtration efficiency, and
                      enhance the overall performance of your vehicle.
                    </p>
                  </div>

                </div>
                <div>
                  {" "}
                  <Divider orientation="vertical" />
                </div>
                <div
                  className={classes.QualityPara}
                  style={{ paddingLeft: "5%", paddingRight: "5%" }}
                >
                  <div className={classes.imageContainer}>
                    {" "}
                    <img
                      src={manufacturing}
                      alt={'manufacturing'}
                      style={{
                        objectFit: "contain",
                        // width: "25%",
                        // height: "25%",
                        width: 70,
                        height: 70,
                      }}
                    />
                  </div>
                  <p>
                    <span className={classes.bulletHeadings}>
                      Manufacturing Processes
                    </span>
                  </p>
                  <p className={classes.textstyle}>
                    Our state-of-the-art manufacturing facility employs
                    cutting-edge technology and follows industry best practices.
                    From design to production, every step is carefully monitored
                    to maintain the highest quality standards. We adhere to
                    stringent quality control protocols to ensure consistency
                    and reliability in every filter that leaves our facility.
                  </p>
                </div>
                <div>
                  {" "}
                  <Divider orientation="vertical" />
                </div>
                <div
                  className={classes.QualityPara}
                  style={{ paddingLeft: "5%" }}
                >
                  <div className={classes.imageContainer}>
                    {" "}
                    <img
                      src={qualityControl}
                      alt={'quality Control'}
                      style={{
                        objectFit: "contain",
                        // width: "25%",
                        // height: "25%",
                        width: 70,
                        height: 70,
                      }}
                    />
                  </div>
                  <p>
                    <span className={classes.bulletHeadings}>
                      Quality Control
                    </span>
                  </p>
                  <p className={classes.textstyle}>
                    We have implemented a comprehensive quality control system
                    to guarantee the reliability and effectiveness of our
                    filters. Our experienced quality assurance team conducts
                    rigorous testing at various stages of the manufacturing
                    process. This includes material inspections, performance
                    testing, and fitment verification, among others. We are
                    committed to delivering filters that meet or exceed industry
                    specifications.
                  </p>
                </div>
              </div>
              <div className={classes.QualityDev}>
                <div
                  className={classes.QualityPara}
                  style={{ paddingRight: "5%" }}
                >
                  <div className={classes.imageContainer}>
                    {" "}
                    <img
                      src={certification}
                      alt={'certification'}
                      style={{
                        objectFit: "contain",
                        // width: "25%",
                        // height: "25%",
                        width: 70,
                        height: 70,
                      }}
                    />
                  </div>
                  <p>
                    <span className={classes.bulletHeadings}>
                      Certifications and Compliance
                    </span>
                  </p>
                  <p className={classes.textstyle}>
                    We understand the importance of adhering to industry
                    standards and regulations. Our company holds certifications
                    such as ISO 9001, demonstrating our commitment to quality
                    management systems. These certifications validate our
                    processes, ensuring that we consistently meet customer
                    requirements and deliver reliable products.
                  </p>
                </div>
                <div>
                  {" "}
                  <Divider orientation="vertical" />
                </div>
                <div
                  className={classes.QualityPara}
                  style={{ paddingLeft: "2%", paddingRight: "5%" }}
                >
                  <div className={classes.imageContainer}>
                    {" "}
                    <img
                      src={customerSatisfication}
                      alt={'customer Satisfication'}
                      style={{
                        objectFit: "contain",
                        // width: "25%",
                        // height: "25%",
                        width: 70,
                        height: 70,
                      }}
                    />
                  </div>
                  <p>
                    <span className={classes.bulletHeadings}>
                      Customer Satisfaction
                    </span>
                  </p>
                  <p className={classes.textstyle}>
                    Customer satisfaction is at the core of our business. We
                    value feedback from our customers and continuously strive to
                    improve our products and services. Our customer support team
                    is always ready to assist you with any inquiries or concerns
                    you may have.
                  </p>
                </div>
                <div>
                  {" "}
                  <Divider orientation="vertical" />
                </div>
                <div
                  className={classes.QualityPara}
                  style={{ paddingLeft: "5%" }}
                >
                  <div className={classes.imageContainer}>
                    {" "}
                    <img
                      src={research}
                      alt='reaserch'
                      style={{
                        objectFit: "contain",
                        // width: "25%",
                        // height: "25%",
                        width: 70,
                        height: 70,
                      }}
                    />
                  </div>
                  <p>
                    <span className={classes.bulletHeadings}>
                      Research and Development
                    </span>
                  </p>
                  <p className={classes.textstyle}>
                    We invest in ongoing research and development to stay at the
                    forefront of automotive filter technology. By staying
                    up-to-date with the latest advancements, we can continually
                    enhance the performance and efficiency of our filters. Our
                    goal is to provide filters that contribute to the longevity
                    and optimal functioning of your vehicles.
                  </p>
                  {/* <p className={classes.textstyle}>
                    We have developed extensive testing lab over the years to
                    meet IATF 16949:2016 standards and provide highest quality
                    products to our customers. With detailed incoming raw
                    material inspection, during production inspection and after
                    production validation and testing, we make sure product
                    shipping out of factory meets all quality parameters
                    requested by clients. Some of our testing rigs includes -
                  </p>
                  <ul>
                    <li>Multipass Efficiency Testing</li>
                    <li>Leak Testing</li>
                    <li>Rubber Hardness Tester</li>
                    <li>Salt Spray Testing</li>
                    <li>Flow Rate vs Pressure Drop Testing</li>
                    <li>Paper Burst Strength Testing</li>
                    <li>Filter Burst Strength Testing</li>
                    <li>Relief Wall Opening Testing</li>
                  </ul> 
                </div>*/}


              {/* </div> */}

            </div>
          </div>
        </div>
      </Container>
      <Footer />
    </>
  );
};

export default Quality;
